import request from '@/utils/request'

export function findModuleSuppliers(params) {
  return request({
    url: `/module_suppliers`,
    method: 'get',
    params
  })
}

export function findModuleSupplier(id) {
  return request({
    url: `/module_suppliers/${id}`,
    method: 'get'
  })
}

export function findModuleSupplierName(id) {
  return request({
    url: `/module_suppliers/${id}/name`,
    method: 'get'
  })
}

export function findModuleSupplierForm(id) {
  return request({
    url: `/module_suppliers/${id}/form`,
    method: 'get'
  })
}

export function findModuleSupplierModules(id, params) {
  return request({
    url: `/module_suppliers/${id}/modules`,
    method: 'get',
    params
  })
}

export function createModuleSupplier(data) {
  return request({
    url: `/module_suppliers`,
    method: 'post',
    data
  })
}

export function updateModuleSupplier(id, data) {
  return request({
    url: `/module_suppliers/${id}`,
    method: 'put',
    data
  })
}
